export default __webpack_public_path__ + "static/media/section1-img5.27049a2d.png";